import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OwlModule } from 'angular-owl-carousel';
import { NouisliderModule } from 'ng2-nouislider';
import {SharedModule} from '../../shared/shared.module';
import {SidebarOneComponent} from './shared/sidebar/sidebar-one/sidebar-one.component';
import {ProductListComponent} from './shared/list/product-list/product-list.component';
import {ProductsRoutingModule} from './products-routing.module';
import {LazyLoadImageModule} from 'ng-lazyload-image';
import {SearchMediaComponent} from './search-media/search-media.component';
import {MediaDetailComponent} from './media-detail/media-detail.component';
import {MediaDetailComponent as ExclusiveMediaDetailComponent} from '../exclusive/products/media-detail/media-detail.component';
import {ProductModule} from '../product/product.module';
import {TagInputModule} from 'ngx-chips';
import {FormsModule} from '@angular/forms';
import {NgxBootstrapMultiselectModule} from 'ngx-bootstrap-multiselect';
import {MatSelectModule} from '@angular/material/select';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {ShareButtonsModule} from 'ngx-sharebuttons/buttons';
import {BudgetMediaDetailComponent} from './budget-media-detail/budget-media-detail.component';
import {BudgetMediaDetailComponent as ExclusiveBudgetMediaDetailComponent} from '../exclusive/products/budget-media-detail/budget-media-detail.component';

@NgModule({
    declarations: [
        SearchMediaComponent,
        SidebarOneComponent,
        ProductListComponent,
        MediaDetailComponent,
        ExclusiveMediaDetailComponent,
        BudgetMediaDetailComponent,
        ExclusiveBudgetMediaDetailComponent
    ],
    exports: [
        ProductListComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        NgbModule,
        OwlModule,
        NouisliderModule,
        SharedModule,
        ProductsRoutingModule,
        LazyLoadImageModule,
        ProductModule,
        TagInputModule,
        FormsModule,
        NgxBootstrapMultiselectModule,
        MatSelectModule,
        MatSnackBarModule,
        ShareButtonsModule

    ]
})

export class ProductsModule { }
